// ======================================================================
// File Name       : ReservedEmailDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getFormValues, isInvalid, reduxForm } from 'redux-form';
import * as EmailAction from '../../actions/EmailAction';
import * as ReservedEmailAction from '../../actions/ReservedEmailAction';
import DialogConfirm from '../../components/DialogConfirm';
import ReservedEmailInfo from '../../components/email/ReservedEmailInfo';
import Header from '../../components/Header';
import { MODE } from '../../constants';
import { RESERVED_EMAIL_EDIT } from '../../constants/FunctionConstants';
import { MSG_DEL_EMAIL } from '../../constants/MessageTemplate';
import { EMAIL, RESERVED_EMAIL_LIST } from '../../constants/PathConstants';
import { canAccess } from '../../utils/AuthedUtils';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class ReservedEmailDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteModal: false,
    };
    this.onDeleteDialogCancel = this.onDeleteDialogCancel.bind(this);
    this.onDeleteDialogOk = this.onDeleteDialogOk.bind(this);
    this.openDeleteDialog = this.openDeleteDialog.bind(this);
  }

  componentWillMount() {
    const { dispatch, match } = this.props;
    dispatch(ReservedEmailAction.getReservedEmailDetail(match.params.id));
  }

  openDeleteDialog() {
    this.content = MSG_DEL_EMAIL;
    this.setState({ showDeleteModal: true });
  }

  onDeleteDialogCancel() {
    this.setState({ showDeleteModal: false });
  }

  onDeleteDialogOk() {
    const { reservedEmailInfo, history } = this.props;
    const editType = MODE.DELETE_MODE;
    const param = {
      emailSenderIdAuto: reservedEmailInfo.emailSenderIdAuto,
    };

    this.props.dispatch(EmailAction.registerEditMail(editType, param)).then((error) => {
      !error && history.push(RESERVED_EMAIL_LIST);
    });

    this.setState({ showDeleteModal: false });
  }
  render() {
    const canEditDelete = canAccess(RESERVED_EMAIL_EDIT);
    const { reservedEmailInfo } = this.props;
    const link = reservedEmailInfo ? `/${EMAIL}/reserved/${reservedEmailInfo.emailSenderIdAuto}/edit` : '';
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.RESERVED_EMAIL_LIST}
          text="予約メールに戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="予約メールの詳細" />
        <Col sm={12}>
          <ReservedEmailInfo />
        </Col>
        <Col sm={12} className="text-center margin-top-20">
          {canEditDelete &&
          <Link
            className="btn btn-primary btn-96 margin-10"
            role="button"
            to={link}
          >
            編集
          </Link>}
          {canEditDelete &&
          <Button
            variant="primary"
            className="btn-96 margin-10"
            onClick={this.openDeleteDialog}
          >
            削除
          </Button>}
        </Col>
        <DialogConfirm
          showModal={this.state.showDeleteModal}
          onCancel={this.onDeleteDialogCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDeleteDialogOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { reservedEmailInfo } = state.reservedEmail;
  const filterData = getFormValues('reservedEmailDetail')(state);
  const invalid = isInvalid('reservedEmailDetail')(state);
  return {
    ...{ reservedEmailInfo },
    filterData,
    invalid,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'reservedEmailDetail', // a unique identifier for this form
  touchOnChange: true,
})(ReservedEmailDetailContainer));
